import { render, staticRenderFns } from "./DeliveryStatus.vue?vue&type=template&id=7c6fdcda&scoped=true&"
import script from "./DeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatus.vue?vue&type=style&index=0&id=7c6fdcda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6fdcda",
  null
  
)

export default component.exports